import { useEffect, useState, useMemo, useCallback } from "react";
import useFetch from "./useFetch";
import useDeepCompareEffect from "./useDeepCompareEffect";

const useGetListAndSelectItem = ({ url = "", method = "GET", paginationData = null, additionalQuery = {} }) => {
  const [limit, setLimit] = useState(paginationData?.limit || 10);
  const [offset, setOffset] = useState(paginationData?.offset || 0);
  const [keyword, setKeyword] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [lists, setLists] = useState([]);

  const memoizedQuery = useMemo(() => ({ limit, offset, keyword, ...(additionalQuery || {}) }), [limit, offset, keyword, additionalQuery]);

  const {
    response: { data, meta },
    status: { done: isLoaded },
    refreshData: originalRefreshData,
  } = useFetch(url, {
    method,
    query: memoizedQuery,
  });

  const refreshData = useCallback(() => {
    originalRefreshData();
  }, [originalRefreshData]);

  useDeepCompareEffect(() => {
    originalRefreshData();
  }, [memoizedQuery]);

  useEffect(() => {
    setLists(data || []);
  }, [data]);

  useEffect(() => {
    if (lists && lists.length > 0) {
      if (selectedItem) {
        const found = lists.find(
          (item) => (item?._id && item?._id === selectedItem?._id) || (item?.id && item?.id === selectedItem?.id)
        );
        if (found) {
          setSelectedItem(found);
        } else {
          setSelectedItem(lists[0]);
        }
      } else {
        setSelectedItem(lists[0]);
      }
    } else {
      setSelectedItem(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lists]);

  const handleOnPaginationChange = ({ limit, offset }) => {
    setLimit(limit);
    setOffset(offset);
  };

  return {
    lists,
    setLists,
    meta,
    isLoaded,
    limit,
    setLimit,
    offset,
    setOffset,
    keyword,
    setKeyword,
    selectedItem,
    setSelectedItem,
    refreshData,
    handleOnPaginationChange,
  };
};

export default useGetListAndSelectItem;
